import { SSE, SSEOptionsMethod } from "sse-ts";

import { CancellablePromise, post } from "@/api";
import { config } from "@/config";
import type { SearchResults, UpsellResult } from "@/types";

export function classicSearch(
  query: string,
  metadata: Record<string, string[]>,
  searchMethodIds: string[],
  resultMethodIds: string[]
): CancellablePromise<SearchResults> {
  const data = {
    query,
    metadata,
    searchMethodIds,
    resultMethodIds
  };

  return post<SearchResults>(`/v1/search/classic`, data);
}

export function compactSearch(query: string, searchMethodIds: string[], resultMethodIds: string[]): SSE {
  return new SSE(`${config.api.pathPrefix}/v1/search/compact`, {
    method: SSEOptionsMethod.POST,
    headers: { "Content-Type": "application/json" },
    payload: JSON.stringify({
      query,
      searchMethodIds,
      resultMethodIds
    })
  });
}

export function upsellSearch(
  query: string,
  metadata: Record<string, string[]>,
  searchMethodIds: string[],
  resultMethodIds: string[],
  unlock = false
): CancellablePromise<UpsellResult> {
  const data = {
    query,
    metadata,
    searchMethodIds,
    resultMethodIds,
    unlock
  };

  return post<UpsellResult>("/v1/search/upsell", data);
}
